export function newestFirst(products) {
  return [...products].sort((a,b)=>Number(b.listing_order)-Number(a.listing_order));
}
export function specValue(product, key) {
  const value = (product[key] || '').trim();
  if (value === 'Confirm on enquiry') return '';
  if (key === 'material') return ({'Solid brass':'Brass', '304 Stainless Steel':'Stainless steel','304 stainless steel':'Stainless steel'})[value] || value;
  return value;
}
export function filterProducts(products, category, query, specs = {}) {
  const words = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  return products.filter(p => (category === 'all' || p.category === category || p.category.startsWith(category + '/'))
    && Object.entries(specs).every(([key, value]) => !value || (key === 'finish' ? p.variants.some(v => v.finish === value) : specValue(p, key) === value))
    && words.every(w => `${p.name} ${p.model} ${p.material} ${p.variants?.map(v=>v.finish).join(' ') || p.finish || ''}`.toLowerCase().includes(w)));
}
export function pageProducts(products, page, size = 24) {
  const pages = Math.max(1, Math.ceil(products.length / size));
  const current = Math.max(1, Math.min(pages, page));
  return { pages, current, products: products.slice((current - 1) * size, current * size) };
}
export function validQuantity(value) {
  const n = Number(value);
  return Number.isInteger(n) && n >= 1 && n <= 99999 ? n : null;
}
export function enquiryText(products, entries) {
  return entries.map(([id, quantity]) => {
    const p = products.find(p => p.id === id);
    if (!p || !validQuantity(quantity)) throw new Error('Invalid enquiry item');
    return `${p.model} | ${p.name} | ${p.configuration_name || 'Standard'} | ${p.finish || ''} | ${quantity} carton(s) | ${Number(p.pack)>0 ? Number(p.pack)*quantity+' pcs' : 'Packing to be confirmed'}${p.url ? `\n${p.url}` : ''}`;
  }).join('\n');
}

async function init(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const $ = s => root.querySelector(s);
  let products = JSON.parse($('[data-catalogue-page]').textContent).products;
  const startPage = Number(root.dataset.page) || 1;
  try {
    const all = [], seen = new Set();
    let url = new URL(location.href); url.search = ''; url.searchParams.set('section_id','filer-wholesale-data');
    while (url) {
      if (seen.has(url.href)) throw new Error('Repeated catalogue page'); seen.add(url.href);
      const response = await fetch(url); if (!response.ok) throw new Error('Catalogue unavailable');
      const dom = new DOMParser().parseFromString(await response.text(),'text/html');
      const data = JSON.parse(dom.querySelector('[data-catalogue-index]').textContent);
      all.push(...data.products);
      url = data.next ? new URL(data.next, location.href) : null;
      if (url) url.searchParams.set('section_id','filer-wholesale-data');
    }
    if (all.length) products = newestFirst(all);
  } catch {
    $('[data-results-count]').textContent = 'Catalogue search is temporarily unavailable. Please reload or use the page links.';
    return; // Keep Shopify-rendered pages intact if the index request fails.
  }
  const variantProducts = () => products.flatMap(p=>p.variants.map(v=>({...p,...v,pack:v.pack || p.pack})));
  const choices = new Map(products.map(p=>[p.id,p.variants[0].id]));
  const chosen = p => ({...p,...p.variants.find(v=>v.id===choices.get(p.id)),pack:p.variants.find(v=>v.id===choices.get(p.id)).pack || p.pack});
  const element = (tag, text, className) => {const e=document.createElement(tag);if(text!=null)e.textContent=text;if(className)e.className=className;return e;};
  const button = (text, attr) => {const e=element('button',text);e.type='button';e.setAttribute(attr,'');return e;};
  const swatchStyles = JSON.parse($('[data-swatch-styles]').textContent);
  const finishColors = {chrome:'#c1c7cb',brushed:'#aab0b2',gunmetal:'#596169',gold:'#c6a154',black:'#242424',white:'#f3f3ef',ivory:'#e4dbc5',green:'#456e51',pink:'#e4b7b5',red:'#bd3037'};
  function choose(p,v) {choices.set(p.id,v.id);render();if(detailDialog.open) updateDetail(p);}
  function options(p, target, swatches) {
    const v=chosen(p), configs=[...new Map(p.variants.map(v=>[v.configuration,v.configuration_name])).entries()];
    if(configs.length>1){const select=element('select');select.setAttribute('aria-label',p.model+' configuration');
      for(const [value,label] of configs){const o=element('option',label);o.value=value;select.append(o);}select.value=v.configuration;
      select.addEventListener('change',()=>choose(p,p.variants.find(x=>x.configuration===select.value && x.finish===v.finish)||p.variants.find(x=>x.configuration===select.value)));target.append(select);}
    const finishes=element('div',null,swatches?'fw-swatches':'fw-options');
    if(swatches && p.variants.filter(x=>x.configuration===v.configuration).length<2){target.append(finishes);return;}
    for(const candidate of p.variants.filter(x=>x.configuration===v.configuration)){
      const b=button(swatches?null:candidate.finish,'data-variant');b.setAttribute('aria-label',p.model+' '+candidate.finish);b.title=candidate.finish;b.setAttribute('aria-pressed',String(v.id===candidate.id));
      if(swatches){b.className='fw-swatch';const ball=element('span');ball.style.setProperty('--finish',finishColors[candidate.finish_key]||'#b9bec2');if(swatchStyles[candidate.finish_key])ball.style.cssText=swatchStyles[candidate.finish_key];b.append(ball);}
      b.addEventListener('click',()=>choose(p,candidate));
      if(swatches){const preview=variant=>{const image=target.querySelector('.fw-photo img');if(image){const url=new URL(variant.image);url.searchParams.set('width','720');image.src=url.href;image.alt=variant.alt||p.name;}};b.addEventListener('mouseenter',()=>preview(candidate));b.addEventListener('mouseleave',()=>preview(chosen(p)));}
      finishes.append(b);
    }target.append(finishes);
  }
  function cardFor(p){
    const v=chosen(p), card=element('article',null,'fw-card');card.dataset.card='';card.dataset.id=p.id;
    const photo=button(null,'data-detail');photo.className='fw-photo';photo.setAttribute('aria-label','View '+p.name+' details');
    const img=element('img');const url=new URL(v.image);url.searchParams.set('width','720');img.src=url.href;img.alt=v.alt||p.name;img.width=720;img.height=720;img.loading='lazy';photo.append(img);
    const title=element('h2');title.append(button(p.name,'data-detail'));card.append(photo,title,element('p',p.model+' · '+v.finish,'fw-model'),element('p',p.material||'','fw-material'));
    options(p,card,true);card.append(element('p',v.pack+' pcs / carton · 1 carton minimum'));const addButton=button('Add to enquiry','data-add');addButton.className='fw-add';card.append(addButton);return card;
  }
  const selected = new Map();
  const storageKey = 'filer-factory-enquiry-v2';
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
    if (Array.isArray(saved)) for (const row of saved) {
      if (Array.isArray(row) && variantProducts().some(p => p.id === row[0]) && validQuantity(row[1])) selected.set(row[0], Number(row[1]));
    }
  } catch { /* Storage may be unavailable; browsing and the current enquiry still work. */ }
  let category = 'all', page = startPage, detailProduct, announcementTimer;
  const categories = $('.fw-categories');
  const filters = [...root.querySelectorAll('[data-spec-filter]')];
  function refreshFilters() {
    const scoped = filterProducts(products, category, '');
    for (const select of filters) {
      const values = [...new Set(scoped.flatMap(p => select.dataset.specFilter==='finish' ? p.variants.map(v=>v.finish) : [specValue(p, select.dataset.specFilter)]).filter(Boolean))].sort();
      const previous=select.value;
      while(select.options.length>1) select.remove(1);
      for(const value of values){const option=document.createElement('option');option.value=value;option.textContent=value;select.append(option);}
      select.value=values.length>1 && values.includes(previous)?previous:'';
      select.hidden=values.length<2;
      select.closest('.fw-filter-field').hidden=select.hidden;
      root.querySelector('label[for="'+select.id+'"]').hidden=select.hidden;
    }
    $('.fw-specifications').hidden=filters.every(select=>select.hidden);
  }
  for(const select of filters) select.addEventListener('change',()=>{if(select.dataset.specFilter==='finish' && select.value)for(const p of products){const v=p.variants.find(v=>v.finish===select.value);if(v)choices.set(p.id,v.id);}page=1;render();});
  const panels = [categories, $('.fw-specifications')];
  const mobile = matchMedia('(max-width:749px)');
  for (const panel of panels) panel.open = !mobile.matches;
  mobile.addEventListener('change', e => { for (const panel of panels) panel.open = !e.matches; });
  const detailDialog = $('[data-detail-dialog]'), enquiryDialog = $('[data-enquiry-dialog]');
  const form = $('.fw-form');
  function announce(message) {
    $('[data-announcement]').textContent = message;
    clearTimeout(announcementTimer);
    announcementTimer = setTimeout(() => { $('[data-announcement]').textContent = ''; }, 2500);
  }
  function render(scroll = false) {
    refreshFilters();
    const specs = Object.fromEntries(filters.map(select => [select.dataset.specFilter, select.value]));
    const count = filters.filter(select => select.value).length;
    $('[data-type-count]').textContent = category === 'all' ? '' : '(1)';
    $('[data-spec-count]').textContent = count ? `(${count})` : '';
    const filtered=category!=='all' || $('[data-search]').value.trim() || filters.some(s=>s.value);
    if(!filtered && page!==startPage){const url=new URL(location.href);for(const key of [...url.searchParams.keys()])if(key.startsWith('page_') || key==='page')url.searchParams.delete(key);location.assign(url.href);return;}
    const matching = filterProducts(products, category, $('[data-search]').value, specs);
    const result = pageProducts(matching, page); page = result.current;
    $('[data-grid]').replaceChildren(...result.products.map(cardFor));
    $('[data-native-pages]').hidden=!!filtered;
    $('[data-client-pages]').hidden=!filtered;
    $('[data-results-count]').textContent = `${matching.length} product${matching.length === 1 ? '' : 's'}${matching.length ? ` · Page ${page} of ${result.pages}` : ''}`;
    $('[data-empty]').hidden = !!matching.length;
    $('.fw-pagination').hidden = !matching.length;
    $('[data-previous]').disabled = page === 1;
    $('[data-next]').disabled = page === result.pages;
    const buttons = [];
    for (let n = 1; n <= result.pages; n++) {
      const button = document.createElement('button');
      button.type = 'button'; button.textContent = n; button.dataset.page = n;
      button.setAttribute('aria-label', `Page ${n}`);
      if (n === page) button.setAttribute('aria-current', 'page');
      buttons.push(button);
    }
    $('[data-pages]').replaceChildren(...buttons);
    for (const b of root.querySelectorAll('button[data-category]')) b.setAttribute('aria-pressed', String(b.dataset.category === category));
    if (scroll) $('.fw-results').scrollIntoView({ block: 'start', behavior: 'instant' });
  }
  function save() {
    try { sessionStorage.setItem(storageKey, JSON.stringify([...selected])); } catch { /* Session-only fallback. */ }
    $('[data-count]').textContent = selected.size;
    $('[data-enquiry-body]').value = enquiryText(variantProducts(), [...selected]);
    $('[data-submit]').disabled = selected.size === 0;
    $('[data-form-status]').textContent = '';
  }
  function add(product, quantity) {
    const total = (selected.get(product.id) || 0) + quantity;
    if (!validQuantity(total)) { announce('Maximum quantity is 99,999 cartons per model.'); return; }
    selected.set(product.id, total); save(); announce(`${product.model} added to your enquiry.`);
  }
  function updateDetail(p) {
    const product=chosen(p);detailProduct=product;
    $('[data-detail-title]').textContent=p.name;
    $('[data-detail-model]').textContent=p.model+' · '+product.configuration_name;
    for(const key of ['material','finish','water','installation']){
      const field=$('[data-detail-'+key+']');field.textContent=product[key]||'';field.parentElement.hidden=!product[key];
    }
    $('[data-detail-pack]').textContent=product.pack+' pcs / carton';
    $('[data-detail-description]').textContent=product.description||'';
    $('[data-detail-hose-row]').hidden=!product.connection_hose_cm;
    $('[data-detail-hose]').textContent=product.connection_hose_cm+' cm';
    const image=$('[data-detail-image]');image.src=product.image;image.alt=product.alt||p.name;
    $('[data-detail-options]').replaceChildren();options(p,$('[data-detail-options]'),false);
  }
  function showDetail(product) {updateDetail(product);$('[data-detail-quantity]').value=1;detailDialog.showModal();}
  function renderEnquiry() {
    const rows = [];
    for (const [id, quantity] of selected) {
      const product = variantProducts().find(p => p.id === id);
      const row = document.createElement('div'); row.className = 'fw-enquiry-row';
      const text = document.createElement('div'), title = document.createElement('strong'), model = document.createElement('small');
      title.textContent = product.name; model.textContent = product.model+' · '+product.configuration_name+' · '+product.finish+' · cartons'+(Number(product.pack)>0?' · '+product.pack+' pcs/carton':''); text.append(title, model);
      const input = document.createElement('input');
      input.type = 'number'; input.min = '1'; input.max = '99999'; input.step = '1'; input.required = true; input.value = quantity;
      input.setAttribute('aria-label', `Quantity for ${product.model}`);
      input.addEventListener('input', () => {
        const value = validQuantity(input.value);
        if (value !== null) { selected.set(id, value); save(); }
      });
      input.addEventListener('change', () => {
        const value = validQuantity(input.value);
        if (value === null) { input.reportValidity(); input.value = selected.get(id); return; }
        selected.set(id, value); save();
      });
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = 'Remove'; remove.setAttribute('aria-label', `Remove ${product.model}`);
      remove.addEventListener('click', () => { selected.delete(id); save(); renderEnquiry(); });
      row.append(text, input, remove); rows.push(row);
    }
    if (!rows.length) { const empty = document.createElement('p'); empty.textContent = 'Your list is empty. Add a product to start.'; rows.push(empty); }
    $('[data-enquiry-items]').replaceChildren(...rows);
  }
  root.addEventListener('click', event => {
    const button = event.target.closest('button'); if (!button) return;
    const card = button.closest('[data-card]');
    if (card) {
      const product = products.find(p => p.id === card.dataset.id);
      if (button.hasAttribute('data-detail')) showDetail(product);
      if (button.hasAttribute('data-add')) add(chosen(product), 1);
    } else if (button.hasAttribute('data-category')) {
      category = button.dataset.category; for(const select of filters) select.value=''; page = 1; render();
      if (matchMedia('(max-width:749px)').matches) categories.open = false;
    } else if (button.hasAttribute('data-reset')) {
      category = 'all'; page = 1; $('[data-search]').value = ''; for (const select of filters) select.value = ''; render();
    } else if (button.hasAttribute('data-page')) { page = Number(button.dataset.page); render(true);
    } else if (button.hasAttribute('data-previous')) { page--; render(true);
    } else if (button.hasAttribute('data-next')) { page++; render(true);
    } else if (button.hasAttribute('data-close')) { button.closest('dialog').close();
    } else if (button.hasAttribute('data-open-enquiry')) { renderEnquiry(); enquiryDialog.showModal();
    } else if (button.hasAttribute('data-detail-add')) {
      const input = $('[data-detail-quantity]'), quantity = validQuantity(input.value);
      if (quantity === null) { input.reportValidity(); return; }
      add(detailProduct, quantity); detailDialog.close();
    }
  });
  $('[data-search]').addEventListener('input', () => { page = 1; render(); });
  form.addEventListener('submit', event => {
    if (!selected.size || !form.reportValidity()) { event.preventDefault(); return; }
    $('[data-enquiry-body]').value = enquiryText(variantProducts(), [...selected]);
  });
  if ($('[data-success]')) selected.clear();
  save(); render();
  if ($('[data-form-result]')) { renderEnquiry(); enquiryDialog.showModal(); }
}
// ponytail: native Shopify pages render 24 cards; the filter index loads metadata in batches of 250. Add server-side catalogue search if index size becomes a bottleneck.
if (typeof document !== 'undefined') {
  document.querySelectorAll('[data-wholesale]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-wholesale]').forEach(init));
}
